import React, { useState } from 'react';
import { Box, Typography, Button, Container, Grid, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import UserUploadCard from '../components/UserUploadCard';
import RecordUploadCard from '../components/RecordUploadCard';
import { useToast } from '../components/ui/ToastProvider';
interface BulkUploadProps {
  onLogout: () => void;
}
export default function BulkUpload({
  onLogout
}: BulkUploadProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showUploadCard, setShowUploadCard] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const {
    showToast
  } = useToast();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleDownloadSample = () => {
    console.log('Download sample Excel');
    showToast('Sample template downloaded', 'success');
  };
  const handleUploadRecords = () => {
    setShowUploadCard(true);
  };
  const handleCloseUploadCard = () => {
    setShowUploadCard(false);
  };
  return <Box sx={{
    width: '100%',
    height: '100%',
    bgcolor: 'background.default'
  }} data-id="element-2615">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-2616" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="bulk-upload" data-id="element-2617" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        xs: '100%',
        sm: `calc(100% - ${240}px)`
      },
      ml: {
        xs: 0,
        sm: `${240}px`
      },
      mt: 8
    }} data-id="element-2618">
        <Container maxWidth="xl" data-id="element-2619">
          {/* Header */}
          <Grid container spacing={2} alignItems="center" sx={{
          mb: 3
        }} data-id="element-2620">
            <Grid item xs={12} md={6} data-id="element-2621">
              <Box sx={{
              display: 'flex',
              alignItems: 'center'
            }} data-id="element-2622">
                <Icon icon="lucide:upload" width={24} height={24} color="#0EA5E9" data-id="element-2623" />
                <Typography variant="h5" component="h1" sx={{
                ml: 1.5,
                fontWeight: 600
              }} data-id="element-2624">
                  Bulk Upload
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} data-id="element-2625">
              <Box sx={{
              display: 'flex',
              gap: 2,
              flexWrap: 'wrap',
              justifyContent: {
                xs: 'flex-start',
                md: 'flex-end'
              }
            }} data-id="element-2626">
                <Button variant="outlined" startIcon={<Icon icon="lucide:download" width={18} height={18} data-id="element-2628" />} onClick={handleDownloadSample} sx={{
                whiteSpace: 'nowrap',
                display: {
                  xs: isMobile ? 'none' : 'inline-flex',
                  sm: 'inline-flex'
                }
              }} data-id="element-2627">
                  Download Sample
                </Button>
                <Button variant="contained" startIcon={<Icon icon="lucide:upload" width={18} height={18} data-id="element-2630" />} onClick={handleUploadRecords} data-id="element-2629">
                  Upload Records
                </Button>
              </Box>
            </Grid>
          </Grid>
          {/* Upload Card */}
          {showUploadCard && <RecordUploadCard onClose={handleCloseUploadCard} data-id="element-2631" />}
        </Container>
      </Box>
    </Box>;
}